'use client'

import { AnimatePresence, motion } from 'framer-motion'
import { CellForm } from '@/widgets/cell-form'
import { BuyForm } from '@/widgets/buy-form/ui/BuyForm'

type FormType = 'buy' | 'sell'

interface FormSwitcherProps {
  activeForm: FormType
}

const formAnimation = {
  initial: { opacity: 0, x: 20 },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'spring',
      damping: 25,
      stiffness: 200
    }
  },
  exit: {
    opacity: 0,
    x: -20,
    transition: {
      duration: 0.2
    }
  }
}

export const FormSwitcher = ({ activeForm }: FormSwitcherProps) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        id="form-section"
        key={activeForm}
        variants={formAnimation}
        initial="initial"
        animate="animate"
        exit="exit"
        className="scroll-mt-16 pt-4 md:pt-10"
      >
        {activeForm === 'sell' ? <CellForm /> : <BuyForm />}
      </motion.div>
    </AnimatePresence>
  )
}
